import classnames from "classnames";
import Button from "../button";
import style from "./style.module.scss";
import type { ConfirmDialogProps } from "../../types";

function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  isDestructive = false,
  isLoading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className={style.overlay}>
      <div className={style.dialog}>
        <h2 className={style.title}>{title}</h2>
        <div className={style.message}>{message}</div>
        <div className={style.actions}>
          <Button onClick={onCancel} isDisabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button
            isPrimary
            className={classnames({ [style.destructive]: isDestructive })}
            onClick={onConfirm}
            isDisabled={isLoading}
          >
            {isLoading ? "Processing..." : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
